import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { VISIBLE } from 'src/constants/appConstants';
import {
    VALIDATE_PRODUCT_DETAILS_FAILURE,
    STORE_UNID_SURGERY_INFO,
} from 'src/pages/reportUsage/redux/action/types';

const useRecordScreenEffect = ({
  validProducts,
  filteredProduct,
  showReportPayment,
  getValidatedItemTableData,
  myCaseResourceType,
  setFilteredProduct,
  checkIfValidProductsInRecordScreen,
  patientDetails,
  patientIdMandatory,
  progressBarClicked,
  dispatch,
  setProgressBarStatus,
  currentActivity,
  setCurrentActivity,
  REPORTPROGRESSTEPS,
  getModifiedButtonVisibilities,
  footerButtonStatuses,
  replenish,
  review,
  procedure,
  updateStoredUnidInfoSurgeryData,
  storedUnidSurgeryData,
  step,
  showUnidInfoScreen,
  unidSurgeryInfo,
  storeUnidSurgeryLocalState,
  steps,
  showORreportScreen,
  submit,
  usageDetails,
  t,
  cancel,
  saveAndExit,
  setFooterButtonStatuses,
  setShowORreportScreen,
  setShowUnidInfoScreen,
  procedurePageVisibility,
  setProgressBarCurrentStep,
  replenishmentPageVisibilityUsage,
  salesOrg,
  procedureTypeUsageVisibility,
  proceduresList,
  getDropdownOptionsRequest,
  procedureInfoDetails,
  getProcedureInfoRequest,
  setProcedureDropdownValue,
  navigateToProcedureScreen,
  setIsProcedureBtnClicked,
  setShowCancelPopUp,
  replenGridData
}) => {
   useEffectWithErrorLogging(() => {
        if (
            validProducts &&
            validProducts.length > 0 &&
            filteredProduct.length > 0 &&
            !showReportPayment
        ) {
            const validatedItemTableData = getValidatedItemTableData(
                filteredProduct,
                validProducts,
                myCaseResourceType
            );
            setFilteredProduct(validatedItemTableData);
            if (
                checkIfValidProductsInRecordScreen(
                    validProducts,
                    validatedItemTableData,
                    patientDetails,
                    patientIdMandatory
                ) &&
                !progressBarClicked
            ) {
                dispatch(setProgressBarStatus(currentActivity));
                !replenishmentPageVisibilityUsage && dispatch(setProgressBarStatus('Replen'));
                setCurrentActivity(
                    REPORTPROGRESSTEPS[
                    REPORTPROGRESSTEPS.findIndex(
                        (activity) => activity === currentActivity
                    ) + 1
                    ]
                );
                const modifiedButtonStatuses = getModifiedButtonVisibilities(
                    myCaseResourceType,
                    footerButtonStatuses,
                    replenishmentPageVisibilityUsage ? replenish : procedurePageVisibility ? procedure : review,
                    !procedurePageVisibility ? review : procedure,
                    true
                );
                setFooterButtonStatuses(modifiedButtonStatuses);
                updateStoredUnidInfoSurgeryData(
                    storedUnidSurgeryData,
                    validatedItemTableData
                );
                if (!replenishmentPageVisibilityUsage) {
                    if (
                        !(
                            procedureTypeUsageVisibility === VISIBLE &&
                            proceduresList?.length > 0
                        )
                    ) {
                        dispatch(getDropdownOptionsRequest('procedures'));
                    }
                    if (
                        !(
                            procedureInfoDetails &&
                            Object.keys(procedureInfoDetails).length > 0
                        )
                    ) {
                        // countryCode !== COUNTRY_CODE_JAPN && countryCode !== undefined
                        //     ?
                        const data = {
                            procedureCode:
                                procedureTypeUsageVisibility === VISIBLE &&
                                    usageDetails?.procedureCode
                                    ? usageDetails?.procedureCode
                                    : '',
                            salesOrg: salesOrg,
                        };
                        setProcedureDropdownValue({
                            procedureCode: usageDetails?.procedureCode,
                            procedureDescription: usageDetails?.procedureDescription,

                        });
                        dispatch(getProcedureInfoRequest('Usage', data));
                        // : null;
                    }
                    if (
                        replenGridData?.some(
                            (data) =>
                                data.isSelected &&
                                !data.shippingDetails &&
                                !data.accountOwned
                        ) && replenishmentPageVisibilityUsage
                    ) {
                        setIsProcedureBtnClicked(true);
                        setShowCancelPopUp(true);
                    } else {
                        navigateToProcedureScreen();
                    }
                }
            } else if (
                checkIfValidProductsInRecordScreen(
                    validProducts,
                    validatedItemTableData,
                    patientDetails
                ) &&
                progressBarClicked
            ) {
                const indexOfNextActivity =
                    REPORTPROGRESSTEPS.findIndex(
                        (activity) => activity === step
                    ) + 1;
                if (
                    showUnidInfoScreen &&
                    Object.keys(unidSurgeryInfo).length > 0
                ) {
                    storeUnidSurgeryLocalState();
                }
                if (
                    steps[step].done ||
                    ((showUnidInfoScreen || showORreportScreen) &&
                        step === 'Procedure')
                ) {
                    dispatch(setProgressBarCurrentStep(step));
                    setCurrentActivity(step);
                    const modifiedButtonStatuses =
                        getModifiedButtonVisibilities(
                            myCaseResourceType,
                            footerButtonStatuses,
                            step === 'Replen'
                                ? !procedurePageVisibility
                                    ? submit
                                    : replenishmentPageVisibilityUsage ? replenish : procedurePageVisibility ? procedure : review
                                : step,
                            REPORTPROGRESSTEPS[indexOfNextActivity] === 'Replen'
                                ? replenishmentPageVisibilityUsage ? replenish : procedurePageVisibility ? procedure : review
                                : REPORTPROGRESSTEPS[indexOfNextActivity] ===
                                    'Submit'
                                    ? usageDetails &&
                                        usageDetails.unidId &&
                                        usageDetails?.unidSurgeryInfoPage
                                            ?.deliveredRodItems?.length > 0
                                        ? //   &&
                                        //   storedItemTableData?.some((item) => {
                                        //       return (
                                        //           item?.cfn?.startsWith('B33') ||
                                        //           item.children?.some((product) =>
                                        //               product?.cfn?.startsWith('B33')
                                        //           )
                                        //       );
                                        //   })
                                        t('reportUsage.progressBar.UNiDInfo')
                                        : review
                                    : !procedurePageVisibility
                                        ? review
                                        : indexOfNextActivity === 2
                                            ? procedure
                                            : indexOfNextActivity === 0
                                                ? replenishmentPageVisibilityUsage ? replenish : procedurePageVisibility ? procedure : review
                                                : !replenishmentPageVisibilityUsage && indexOfNextActivity === 1 ? procedure : '',
                            true
                        );
                    setFooterButtonStatuses(modifiedButtonStatuses);
                    setShowORreportScreen(false);
                    setShowUnidInfoScreen(false);
                }
            } else {
                dispatch({
                    type: VALIDATE_PRODUCT_DETAILS_FAILURE,
                    payload: { validItems: [], productsValidated: true },
                });
                const modifiedButtonStatuses = footerButtonStatuses.map((x) =>
                    x.btnName !== cancel &&
                        x.btnName !== saveAndExit &&
                        x.btnVisibility
                        ? { ...x, isBtnDisable: true }
                        : x
                );
                setFooterButtonStatuses(modifiedButtonStatuses);
            }
        }
    }, [validProducts]);
};

export default useRecordScreenEffect;